<template>
  <div class="row">
    <div class="col-12">
      <form @submit.prevent="onSubmit" ref="company_form">
        <div class="form-group">
          <label>Nome / Razão Social <span class="text-danger">*</span></label>
          <input
            type="text"
            v-model="company.name"
            class="form-control"
            placeholder="Nome / Razão Social"
          />
        </div>

        <div class="form-group row">
          <div class="col-lg-4">
            <label>Telefone</label>
            <input
              type="text"
              v-model="company.telephone"
              class="form-control"
              placeholder="Telefone"
            />
          </div>
          <div class="col-lg-4">
            <label>Tipo / Segmento</label>
            <Dropdown
              v-model="company.company_type"
              :editable="true"
              :options="company_types"
              class="w-100"
              option-label="name"
              option-value="name"
            />
          </div>
          <div class="col-lg-4">
            <label>Unidade</label>
            <input
              type="text"
              v-model="company.unit"
              class="form-control"
              placeholder="Unidade"
            />
          </div>
        </div>

        <div class="form-group">
          <label>E-mail <span class="text-danger">*</span></label>
          <input
            type="email"
            v-model="company.email"
            class="form-control"
            placeholder="E-mail"
          />
        </div>

        <div class="form-group row">
          <div class="col-lg-6">
            <label>CNPJ <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="company.cnpj"
              class="form-control"
              placeholder="CNPJ"
            />
          </div>
          <div class="col-lg-6">
            <label>Inscrição Estadual</label>
            <input
              type="text"
              v-model="company.state_registration"
              class="form-control"
              placeholder="Inscrição Estadual"
            />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-4">
            <label>Número de funcionários</label>
            <input
              type="text"
              v-model="company.number_of_employees"
              class="form-control"
              placeholder="Número de funcionários"
            />
          </div>
          <div class="col-lg-4">
            <label>CEP</label>
            <input
              type="text"
              v-model="company.postal_code"
              class="form-control"
              placeholder="CEP"
            />
          </div>
          <div class="col-lg-4">
            <label>Estado <span class="text-danger">*</span></label>
            <select v-model="company.state_short_name" class="form-control">
              <option
                v-for="state in states"
                :key="state.id"
                :value="state.short_name"
              >
                {{ state.short_name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-4">
            <label>Cidade <span class="text-danger">*</span></label>
            <select v-model="company.city" class="form-control">
              <option v-for="city in cities" :key="city.id" :value="city.name">
                {{ city.name }}
              </option>
            </select>
          </div>
          <div class="col-lg-8">
            <label>Bairro</label>
            <input
              type="text"
              v-model="company.neighborhood"
              class="form-control"
              placeholder="Bairro"
            />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-4">
            <label>Rua <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="company.street"
              class="form-control"
              placeholder="Rua"
            />
          </div>
          <div class="col-lg-4">
            <label>Número <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="company.number"
              class="form-control"
              placeholder="Número"
            />
          </div>
          <div class="col-lg-4">
            <label>Complemento</label>
            <input
              type="text"
              v-model="company.complement"
              class="form-control"
              placeholder="Complemento"
            />
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-6">
            <button class="btn btn-default" type="button" @click="openTable()">{{'<<'}} Voltar para a listagem</button>
          </div>
          <div class="col-6 d-flex flex-row-reverse">
            <button
              class="btn btn-dark"
              :disabled="!company.name || !company.cnpj || !company.email || !company.state_short_name || !company.city || !company.street || !company.number"
            >
              <font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
              {{ submit_text }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row" v-if="isUpdate">
    <div class="col-12">
      <h4 class="text-center mb-3">Ordens de serviço</h4>
      <DataTable
        :value="orders_of_service"
        :loading="loadingOrdersOfService"
        :paginator="false"
        :total-records="total_orders_of_service"
        class="p-datatable-gridlines p-datatable-sm"
        data-key="id"
        :row-hover="true"
        ref="datatable"
      >
        <template #empty> Nenhum resultado </template>
        <Column field="id" header="ID"></Column>
        <Column field="name" header="Nome"></Column>
        <Column header="Ações">
          <template #body="{ data }">
            <div class="d-flex flex-nowrap justify-content-end">
              <button
                class="btn btn-warning ml-3"
                @click="updateOrderOfService(data)"
              >
                <font-awesome-icon
                  :icon="['fas', 'wrench']"
                ></font-awesome-icon>
              </button>
            </div>
          </template>
        </Column>
      </DataTable>


      <button
        class="btn btn-dark mt-3"
        @click="newOrderOfService()"
      >
        <font-awesome-icon :icon="['fas', 'save']"></font-awesome-icon>
        Nova ordem de serviço
      </button>
    </div>
  </div>
  <Dialog
    :closable="false"
    :visible="displayModal"
    :style="{ width: '80vw' }"
    :modal="true"
    class="modal-content"
  >
    <template #header class="modal-header">
      <div class="d-flex">
        <h5 class="modal-title mr-5">
          {{ order_of_service.order_of_service_id ? 'Editar' : 'Nova' }} ordem de serviço
        </h5>

      </div>
    </template>

    <div class="modal-body">
      <div class="ml-4">
        <div class="row form-group">
          <div class="col-lg-12">
            <div class="form-group">
              <label>Nome</label>
              <input
                v-model="order_of_service.name"
                type="text"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <button class="btn btn-default" @click="closeModal()">Cancelar</button>
      <button class="btn btn-success" @click="saveOrderOfService()">
        Salvar
      </button>
    </template>
  </Dialog>
</template>

<script>
  import { onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import axios from 'axios'

  import useCompanies from '@/modules/Company.js'
  import useAddresses from '@/modules/Address.js'
  import useSwal from '@/modules/Swal.js'
  import Dropdown from 'primevue/dropdown'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import Dialog from 'primevue/dialog'
  import useCompanyTypes from '@/modules/CompanyType.js'

  export default {
    setup() {
      const route = useRoute()
      const router = useRouter()

      const { showErrorDialog } = useSwal()

      const loading = ref(true)
      const company_form = ref(null)

      const {
        states,
        listStates,
        cities,
        listCitiesByStateShortName,
      } = useAddresses()

      const company = ref({
        company_id: null,
        name: '',
        telephone: '',
        email: '',
        unit: '',
        cnpj: '',
        state_registration: '',
        number_of_employees: null,
        company_type: '',
        city: '',
        postal_code: '',
        street: '',
        number: '',
        state_short_name: '',
        complement: '',
        neighborhood: '',
      })

      const isUpdate = route.params.id ? true : false

      const submit_text = ref('')

      const { company_types, listCompanyTypes } = useCompanyTypes()

      const { getCompany, saveCompany, listCompanies } = useCompanies()

      const onSubmit = () => {
        saveCompany(company.value)
          .then(() => {
            listCompanies()
            router.push('/companies')
          })
          .catch((error) => {
            console.log(error)
            const message = error?.response?.data?.error || 'Verifique os dados e tente novamente.'
            showErrorDialog(message)
          })
      }

      onMounted(async () => {
        await listStates()
        await listCompanyTypes()

        if (route.params.id) {
          await getCompany(route.params.id).then((response) => {
            company.value = response.data.data
            company.value.company_type = response.data.data.company_type?.name
          })

          submit_text.value = 'Salvar alterações'
        } else {
          submit_text.value = 'Cadastrar'
        }

        loading.value = false
      })

      return {
        company_types,
        states,
        cities,
        listCitiesByStateShortName,
        route,
        company_form,
        company,
        submit_text,
        onSubmit,
        isUpdate,
        router
      }
    },
    data() {
      return {
        displayModal: false,
        orders_of_service: [],
        total_orders_of_service: 0,
        order_of_service: {
          order_of_service_id: '',
          name: ''
        },
        loadingOrdersOfService: false,
      }
    },
    computed: {
      selected_state() {
        return this.company.state_short_name
      },
    },
    watch: {
      selected_state() {
        this.listCitiesByStateShortName(this.selected_state)
      },
    },
    methods: {
      async loadOrdersOfService() {
        this.loadingOrdersOfService = true

        await axios.get(`/api/orders_of_service/searchAndPaginate?page=1&per_page=9999&company_id=${this.route.params.id}`)
          .then(({data}) => {
            this.orders_of_service = data.data
            this.total_orders_of_service = data.data.length
          })
          .catch(error => {
            console.log(error)
            return null
          })

        this.loadingOrdersOfService = false
      },
      newOrderOfService() {
        this.order_of_service = {}
        this.displayModal = true
      },
      updateOrderOfService(data) {
        this.order_of_service = {
          order_of_service_id: data.id,
          name: data.name
        }
        this.displayModal = true
      },
      closeModal() {
        this.order_of_service = {}
        this.displayModal = false
      },
      async saveOrderOfService() {
        const request = {
          url: '/api/orders_of_service/storeOrUpdate',
          data: new FormData(),
          config: {
            headers: {
              'content-type': 'multipart/form-data',
            },
          },
        }

        if (this.order_of_service.order_of_service_id)
          request.data.append('order_of_service_id', this.order_of_service.order_of_service_id)

        request.data.append('company_id', this.company.company_id)
        request.data.append('name', this.order_of_service.name)

        await this.axios.post(request.url, request.data, request.config)
          .then(data => {
            console.log('running')
            this.loadOrdersOfService()
            return data
          })
          .catch(error => {
            console.log(error)
            return null
          })

        this.closeModal()
      },
      openTable() {
        this.router.push('/companies');
      }
    },
    mounted() {
      this.loadOrdersOfService()
    },
    components: {
      Dropdown,
      DataTable,
      Column,
      Dialog,
    },
  }
</script>
